import { Employee } from '@/types/profile/employeeColumnDef';
import { UpdateEmployeeFormData } from '@/types/profile/UpdateEmployeeFormData';

// Employees created before phone numbers were collected have none, and the
// API sends null for it, which the form schema rejects.
export const toUpdateEmployeeFormValues = (
  employee: Employee,
): UpdateEmployeeFormData => ({
  firstName: employee.firstname,
  lastName: employee.lastname,
  email: employee.email,
  password: undefined,
  phoneNumber: employee.phoneNumber ?? undefined,
});
